import $ from 'jquery'

import Swiper from './utils/getSwiper'

import { positionImages } from './positionImages'

const TOUCH_MOVE_TRIGGER_VW = 10,
  SWIPE_SPEED_MS = 500

let memoryStartX = 0,
  touchMoveTrigger = vwConverter(TOUCH_MOVE_TRIGGER_VW),
  isTouchDevice = false,
  isMobileSize = false

function init () {
  initVideoPopUpListener()
  $('.asset-slider-module').each(function () {
    containerSwitch($(this))
    accordionEvent($(this))
    initSliders($(this))
  })
}

function initVideoPopUpListener () {
  $('.popup-video').on('click', function () {
    let videoPopUpID = $(this).closest('.asset-text-slide.swiper-slide-active').attr('data-video-popup')
    if (videoPopUpID != undefined) {
      $(videoPopUpID).modal('show')
    }
  })
}

// only reinit slider if its in accordion
function accordionEvent ($module) {
  if ($($module).parents('.accordion').length == 1) {
    const accordion = $module.parents('.accordion')
    accordion.on('shown.bs.collapse', function () {
      $module.trigger('reinit')
    })
  }
}

function containerSwitch ($module) {
  calcContainerSwitch()
  $(window).on('resize', calcContainerSwitch)

  function calcContainerSwitch () {
    let container = $module.find('.asset-slider-container-switch')
    if ($(window).width() < 992) {
      container.removeClass('container').addClass('container-fluid')
    } else {
      container.removeClass('container-fluid').addClass('container')
    }
  }
}

function initSliders ($module) {
  let $iconSlider = $module.find('.asset-icon-icon-slider'),
    $textSlider = $module.find('.asset-icon-text-slider'),
    swiperIcons,
    swiperText

  $iconSlider.data('slideMemory', 0)
  isMobileSize = $(window).width() < 992

  swiperIcons = new Swiper($iconSlider.get(0), getConfig(true, $module, $iconSlider))
  swiperText = new Swiper($textSlider.get(0), getConfig(false, $module))

  swiperIcons.on('slideNextTransitionStart', () => {
    swiperText.slideToLoop(swiperIcons.realIndex)
  })
  swiperIcons.on('slidePrevTransitionStart', () => {
    swiperText.slideToLoop(swiperIcons.realIndex)
  })
  swiperText.on('resize', function () {
    swiperText.slideTo(swiperIcons.realIndex)
  })

  $module.on('reinit', function () {
    swiperIcons.destroy(true, true)
    swiperIcons = new Swiper($iconSlider.get(0), getConfig(true, $module, $iconSlider))
    swiperText.destroy(true, true)
    swiperText = new Swiper($textSlider.get(0), getConfig(false, $module))
  })

  setTextTouchSwipe(swiperIcons, swiperText)

  $iconSlider.data('rebuild', $(window).width() >= 992)

  $(window).on('resize', () => {
    isMobileSize = $(window).width() < 992
    if ($(window).width() < 992 && $iconSlider.data('rebuild') && !swiperIcons.params.loop) {
      // fixes issue while transitioning from loop: false to loop: true
      let currentIndex = swiperIcons.realIndex

      swiperIcons.destroy(true, true)
      swiperIcons = new Swiper($iconSlider.get(0), getConfig(true, $module, $iconSlider, currentIndex))
      swiperIcons.on('slideNextTransitionStart', () => {
        swiperText.slideToLoop(swiperIcons.realIndex)
      })
      swiperIcons.on('slidePrevTransitionStart', () => {
        swiperText.slideToLoop(swiperIcons.realIndex)
      })
      setTextTouchSwipe(swiperIcons, swiperText)
      $iconSlider.data('rebuild', false)
    } else if ($(window).width() >= 992) {
      $textSlider.find('.swiper-wrapper').css('height', '')
      $iconSlider.data('rebuild', true)
    }
    // ie11 resize fix (ie11 kills the slider sometimes on resize)
    if (isNaN(swiperIcons.activeIndex)) {
      swiperIcons.destroy(true, true)
      swiperIcons = new Swiper($iconSlider.get(0), getConfig(true, $module, $iconSlider))
      swiperIcons.on('slideNextTransitionStart', () => {
        swiperText.slideToLoop(swiperIcons.realIndex)
      })
      swiperIcons.on('slidePrevTransitionStart', () => {
        swiperText.slideToLoop(swiperIcons.realIndex)
      })
      setTextTouchSwipe(swiperIcons, swiperText)
    }
  })
  $(window).on('touchstart', setTouch)

  function setTouch () {
    isTouchDevice = true
    swiperIcons.allowTouchMove = true
    swiperText.allowTouchMove = true
    swiperIcons.update(true, true)
    swiperText.update(true, true)
    $(window).off('touchstart', setTouch)
    $(window).data('test', swiperIcons)
  }

  //fix for safari, hover effects are not working without timeout
  setTimeout(function () {
    positionImages($iconSlider.find('.img-fill-asset-slider'))
    swiperIcons.update(true, true)
    swiperText.update(true, true)
  }, 250)
}

function setTextTouchSwipe (swiperIcons, swiperText) {
  swiperText.off('touchMove')
  swiperText.on('touchMove', function () {
    let startX = swiperText.touches.startX,
      currentX = swiperText.touches.currentX

    if (startX > currentX && startX - currentX >= touchMoveTrigger && memoryStartX !== startX) {
      swiperIcons.slideNext()
      memoryStartX = startX
    } else if (startX < currentX && currentX - startX >= touchMoveTrigger && memoryStartX !== startX) {
      swiperIcons.slidePrev()
      memoryStartX = startX
    }
  })
}

function getConfig (isIcon, $module, $iconSlider = null, currentIndex = null) {
  let $arrowPrev = $module.find('.prev'),
    $arrowNext = $module.find('.next'),
    $pagination = $module.find('.current-slide-index'),
    $Slides = $module.find('.asset-icon-icon-slider .swiper-slide'),
    countSlides = $module.find('.asset-icon-icon-slider .swiper-slide').length
  if (isIcon) {
    return {
      centeredSlides: true,
      slidesPerView: 3,
      spaceBetween: 0,
      loop: countSlides >= 5,
      allowTouchMove: isTouchDevice,
      speed: SWIPE_SPEED_MS,
      slideToClickedSlide: true,
      loadPrevNext: true,
      threshold: 100000,
      navigation: {
        nextEl: $arrowNext.get(0),
        prevEl: $arrowPrev.get(0)
      },
      pagination: {
        el: $pagination.get(0),
        type: 'custom',
        renderCustom: function (swiper, index) {
          return index
        }
      },
      breakpoints: {
        576: {
          spaceBetween: calcOffset($Slides, 3),
          slidesPerView: 'auto',
          allowTouchMove: true,
          loop: true
        },
        768: {
          spaceBetween: calcOffset($Slides, 5),
          slidesPerView: 'auto',
          allowTouchMove: true,
          loop: true
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 20,
          allowTouchMove: true,
          loop: true
        },
      },
      on: {
        init: function () {
          if (currentIndex !== null) {
            if (this.params.loop) {
              this.slideToLoop(currentIndex, 0)
            } else {
              this.slideTo(currentIndex, 0)
            }
          }
        },
        touchMove: function () {
          // this will change the touch-move to slide only 1 slide pre swipe including the slide-animation
          let startX = this.touches.startX,
            currentX = this.touches.currentX

          if (startX > currentX && startX - currentX >= touchMoveTrigger && memoryStartX !== startX) {
            this.slideNext()
            memoryStartX = startX
          } else if (startX < currentX && currentX - startX >= touchMoveTrigger && memoryStartX !== startX) {
            this.slidePrev()
            memoryStartX = startX
          }
        },
        resize: function () {
          if ($(window).width() < 576) {
            this.params.spaceBetween = calcOffset($Slides, 3)
          } else if ($(window).width() < 992) {
            $(this.slides).css('width', 'auto')
            this.params.spaceBetween = calcOffset($Slides, 5)
          } else {
            this.params.spaceBetween = 80
            if (countSlides < 5 && $module.find('.swiper-slide-duplicate').length > 0) {
              $module.find('.swiper-slide-duplicate').remove()
            }
          }
          touchMoveTrigger = vwConverter(TOUCH_MOVE_TRIGGER_VW)
          this.slideToLoop($iconSlider.data('slideMemory'), 0, false)
          this.update(true, true)
        },
        slideChangeTransitionEnd: function () {
          this.slideToLoop(this.realIndex, 0, false)
          $iconSlider.data('slideMemory', this.realIndex)
        }
      }
    }
  } else {
    return {
      slidesPerView: 1,
      loop: false,
      speed: SWIPE_SPEED_MS,
      spaceBetween: 15,
      allowTouchMove: isTouchDevice,
      autoHeight: false,
      threshold: 100000,
      effect: 'fade',
      breakpoints: {
        992: {
          allowTouchMove: true,
          autoHeight: true
        }
      }
    }
  }
}

function vwConverter (vw) {
  return Math.round($(window).width() * (vw / 100))
}

function calcOffset ($swipes, shownSwipes) {
  let windowWidth = $(window).width(),
    $firstSwipe = $($swipes[0]),
    swipeWidth = $firstSwipe.width() + parseInt($firstSwipe.css('padding-left')) + parseInt($firstSwipe.css('padding-right'))

  return (Math.round((windowWidth - (swipeWidth * (shownSwipes - 1))) / (shownSwipes - 1)) / 2)
}

export default {
  init
}
